import { FormattedMessage } from 'react-intl'

import type { ProductPropertyKey } from '../../@types'

export const LABELS_MAP: Record<ProductPropertyKey, React.ReactNode> = {
  color: <FormattedMessage id="fields.color.label" />,
  gender: <FormattedMessage id="fields.gender.label" />,
  size: <FormattedMessage id="fields.size.label" />,
  brand: <FormattedMessage id="fields.brand.label" />,
  condition: <FormattedMessage id="fields.condition.label" />,
  material: <FormattedMessage id="fields.material.label" />,
  pattern: <FormattedMessage id="fields.pattern.label" />,
} as const
